import type {
  Acknowledgement,
  MagicLinkRequest,
  SessionResponse,
} from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function requestMagicLink(req: MagicLinkRequest): Promise<Acknowledgement> {
  return apiFetch<Acknowledgement>('/auth/magic-link', { method: 'POST', json: req });
}

export async function getSession(): Promise<SessionResponse> {
  return apiFetch<SessionResponse>('/auth/session', { method: 'GET' });
}

export async function logout(): Promise<Acknowledgement> {
  return apiFetch<Acknowledgement>('/auth/logout', { method: 'POST' });
}
